import type { HelpArticle, HelpSearchHit } from "@/lib/registrant-help/types";
import { TITLE_HELP_ARTICLES } from "@/lib/title-help/articles";

function flatten(article: HelpArticle): string {
  return [
    article.title,
    article.summary,
    article.keywords.join(" "),
    ...article.sections.flatMap((section) => [
      section.heading,
      ...section.blocks.flatMap((block) =>
        block.type === "p" ? [block.text] : block.items,
      ),
    ]),
  ]
    .join(" ")
    .toLowerCase();
}

export function searchTitleHelpArticles(query: string): HelpSearchHit[] {
  const terms = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (terms.length === 0) return [];
  return TITLE_HELP_ARTICLES.flatMap((article) => {
    const haystack = flatten(article);
    if (!terms.every((term) => haystack.includes(term))) return [];
    return [{ article, score: 1 }];
  });
}
